import jwtDecode from 'jwt-decode'
import { UserRole } from '../domain/enuns/UserRole'
import { Student } from '../domain/entities/Student'
import { Teacher } from '../domain/entities/Teacher'
import api from './api'
import { setLocalStorageItem } from '../helpers'

export async function handleLogin(loginData: any, token: string = ''): Promise<Student | Teacher> {
  try {
    let url
    let authToken
    let credentials

    if (token) {
      const user = jwtDecode(token) as Record<any, any>
      const userType = user['role']
      authToken = token
      credentials = { token: user['userToken'] }

      url =
        userType === UserRole.teacher
          ? `${process.env.REACT_APP_LOGIN_API}/user/GetServidorByToken`
          : `${process.env.REACT_APP_LOGIN_API}/user/GetAlunoByToken`
    } else {
      const authData = await api.post(`${process.env.REACT_APP_LOGIN_API}/account/login`, loginData)
      const user = jwtDecode(authData.data.access_token) as Record<any, any>
      authToken = authData.data.access_token
      credentials = { user: loginData.username, password: loginData.password }

      url =
        user['role'] === UserRole.teacher
          ? `${process.env.REACT_APP_LOGIN_API}/user/GetServidor`
          : `${process.env.REACT_APP_LOGIN_API}/user/GetAluno`
    }

    const userData = await api.post(url, credentials, {
      headers: { Authorization: `Bearer ${authToken}` },
    })

    console.log('userData', userData.data)
    let storageData = { ...userData.data, authToken, perfis: [] }

    // Só tenta autenticar no adm se for servidor
    if (userData.data.tipoUsuario[0] === 2) {
      try {
        const admUrl = `${process.env.REACT_APP_ADM_SERVICE}/Auth?sistema=37`

        const userAdm = await api.post(
          admUrl,
          {
            user: loginData.username,
            password: admUrl.includes('localhost') || admUrl.includes('hom') ? 'treinamento' : loginData.password,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          }
        )

        if (userAdm.data?.usuario.sistemas?.some((sistema: any) => sistema.id === 37)) {
          storageData.perfis = userAdm.data.usuario.sistemas.find((sistema: any) => sistema.id === 37).perfis.map((p: any) => ({ id: String(p.id), nome: p.nome })) ?? [];
          console.log('Perfis encontrados:', storageData.perfis)
        }
      } catch (admError) {
        // Erro não impede o login no netescola
        console.warn('Usuário sem autenticação no adm', admError);
        storageData.perfis = []
      }
    }

    setLocalStorageItem('netescola', storageData)

    return storageData
  } catch (error) {
    throw error
  }
}
